import {
  Toast,
  ToastClose,
  ToastDescription,
  ToastProvider,
  ToastTitle,
  ToastViewport,
} from "./Toast";
import { useToast } from "./useToast";

export function Toaster() {
  const { toasts } = useToast();

  const getViewPortPositionClassName = () => {
    if (toasts.some((toast) => toast.position === "bottom-left")) {
      return "bottom-0 left-0";
    }
    if (toasts.some((toast) => toast.position === "top")) {
      return "top-0";
    }

    return "bottom-0 right-0";
  };

  return (
    <ToastProvider>
      {toasts.map(function ({ id, title, description, action, ...props }) {
        return (
          <Toast key={id} {...props}>
            <div className="grid gap-1">
              {title && <ToastTitle>{title}</ToastTitle>}
              {description && (
                <ToastDescription>{description}</ToastDescription>
              )}
            </div>
            {action}
            <ToastClose />
          </Toast>
        );
      })}
      <ToastViewport className={getViewPortPositionClassName()} />
    </ToastProvider>
  );
}
